import React from "react";
import { getMaxLength } from "../../../../application/domain/proc-management/util/input-max-length";
import { FormFieldLabel } from "../../../atoms/proc-management/form";
import { InputNoticeList } from "./input-notice-list";
import { SimpleTextAreaInput } from "./simple-textarea-input";
import type { InputProps, PathProps } from "./types";

const notices = [
  "コンビニ交付を利用するにあたって特有の注意書きが必要な場合、記述します。",
  "例: 令和2年度分の証明書のみ取得できます。サンプル市に住民登録があり、サンプル市で申告されている本人分のみ取得できます。",
];

type Props = InputProps & PathProps & { value?: string; errorMsg?: string };

export const ProcedureAtStoreInfoNoticeInput: React.FC<Props> = ({
  onChange,
  disabled = false,
  basePath,
  value,
  shouldDisplayError = false,
  errorMsg,
}) => {
  return (
    <div className="field mb-6">
      <FormFieldLabel label="コンビニ交付注意書き" />
      <InputNoticeList notices={notices} />
      <SimpleTextAreaInput
        onChange={onChange}
        basePath={basePath}
        value={value}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={errorMsg}
        maxLength={getMaxLength("atStoreNotice")}
      />
    </div>
  );
};
